export const ADDRESS_TEXT_PATTERN = /^[a-zA-Z0-9 .'-]*$/;
export const LOCALITY_PATTERN = /^[a-zA-Z .'-]*$/;
export const POSTCODE_PATTERN = /^[a-zA-Z0-9 ]*$/;
